// @flow
import React, { Fragment, useContext } from 'react';

import ResponsiveContext from 'Components/utils/responsive/responsiveContext';

import { type LineProps } from 'Client/cms/toolkit/product-accommodations/productAccommodations.resolver';
import { Introduction } from 'Components/frameworks/introduction/Introduction.jsx';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer.jsx';
import { Tabs } from 'Components/frameworks/tabs/Tabs.jsx';
import { mapItemForTabs } from 'Components/lines/product-accommodations-line/productAccommodations.utils';

export const ProductAccommodationsLine = (props: LineProps) => {
  const items = mapItemForTabs(props);
  const {
    config: { common: { loadLess, scrollBackward, scrollForward, viewMore } = {} } = {},
    id,
    resort: { accommodationsIntroduction },
  } = props;

  const { isTablet } = useContext(ResponsiveContext);

  const content = (
    <Fragment>
      {accommodationsIntroduction && (
        <SiteContainer isWide={isTablet}>
          <Introduction
            className="mb-4"
            dataTestId="Line-Product-Accommodations__Introduction"
            title={accommodationsIntroduction.shortDescription}
            text={accommodationsIntroduction.description}
            seeMoreLabel={viewMore}
            seeLessLabel={loadLess}
          />
        </SiteContainer>
      )}
      <Tabs
        isScrollable
        items={items}
        scrollBackwardLabel={scrollBackward}
        scrollForwardLabel={scrollForward}
        theme="lite"
      />
    </Fragment>
  );

  return isTablet ? (
    <SiteContainer className="Line" id={id}>
      {content}
    </SiteContainer>
  ) : (
    <div className="Line" id={id}>
      {content}
    </div>
  );
};
